import { bbt, type TempoSource } from '@srs/shared';
import { useEffect, useState, useSyncExternalStore } from 'react';

// Kleine Meldungen unten in der Mitte
let msg = '';
const subs = new Set<() => void>();
let timer: number | undefined;
export function toast(text: string, ms = 3200) {
  msg = text; subs.forEach((s) => s());
  clearTimeout(timer);
  timer = window.setTimeout(() => { msg = ''; subs.forEach((s) => s()); }, ms);
}
export function Toast() {
  const text = useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, () => msg);
  return text ? <div className="toast">{text}</div> : null;
}

/** Ruft fn in jedem Animationsframe auf und liefert den Wert (für Pegel, Uhr) */
export function useFrame<T>(fn: () => T, deps: unknown[] = []): T {
  const [v, setV] = useState(fn);
  useEffect(() => {
    let raf = 0;
    const loop = () => { setV(fn()); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return v;
}

export const Panel = ({ title, right, children, className = '', style }: { title?: React.ReactNode; right?: React.ReactNode; children: React.ReactNode; className?: string; style?: React.CSSProperties }) => (
  <section className={`panel ${className}`} style={style}>
    {title !== undefined && <div className="ph"><h2>{title}</h2>{right && <div className="r">{right}</div>}</div>}
    {children}
  </section>
);

export const Meter = ({ level, height = 170 }: { level: number; height?: number }) => {
  const db = level > 0 ? 20 * Math.log10(level) : -96;
  const pct = Math.max(0, Math.min(100, ((db + 60) / 60) * 100));
  return <div className="meter" style={{ height }}><i style={{ height: `${pct}%` }} /></div>;
};

export const fmtTime = (s: number) => {
  const m = Math.floor(s / 60), sec = s - m * 60;
  return `${String(m).padStart(2, '0')}:${sec.toFixed(2).padStart(5, '0')}`;
};
export const fmtBars = (p: TempoSource, s: number) => { const x = bbt(p, s + 1e-7); return `${x.bar}.${x.beat}.${String(x.tick).padStart(3, '0')}`; };
